<template>

    <div id="booking_pdf" class=""  v-if="hasPdfs">
      <table class="table table-bordered table-responsive">
        <thead>
        <tr class="header-details-summary">
          <th><b>{{trans.date}}</b></th>
          <th><b>{{trans.attachment}}</b></th>
          <th><b>{{trans.description}}</b></th>
          <th><b>{{trans.size}}</b></th>
          <th><b>{{trans.user}}</b></th>
        </tr>
        </thead>
        <tbody>

        <!--   view all atachments as rows on the table   -->
        <tr v-for="(pdf, index ) in pdfs" :key="index" >
          <td> {{pdf.created}} </td>
          <td style=""> <a target="_blank" :href="pdf.viewURL"> <i class="fa fa-file-archive-o"></i>{{pdf.file_name}}</a> </td>
          <td> {{pdf.description}}</td>
          <td > {{pdf.size}}</td>
          <td> {{pdf.username}}</td>
        </tr>
        </tbody>
      </table>
    </div>


</template>


<script>

import {getBookingPdfs} from "@/modules/CustomerPortal/api/bookings/view";

export default {
  name: "BookingViewPdfs",
  components: {getBookingPdfs},
  props: [
    "booking_id",
    "company_name",
    "company_id"
  ],
  data() {
    return {
      pdfs: [],
      imagesArr: [],
      hasPdfs: 0,
      trans:[],
    }
  },
  methods:{

  },
  computed: {


  },
  mounted(){
    getBookingPdfs(this.booking_id, this.company_name, this.company_id).then((response) => {
      if(response.status == 200){
        if(response.data.type == 'success'){
          this.pdfs = response.data.data.pdfs;
          this.hasPdfs = (this.pdfs.length) ? 1 : 0 ;
          this.trans = response.data.data.trans;

        }
      }
      return response
    });
  }
}



</script>

<style scoped>
td {
  vertical-align: middle !important;
}

.detail_block a{
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 13px;
  color: #2a6496;
  display: block;
  float: left;
}

.detail_block a:hover {
  text-decoration: underline;
}
td .fa {

  margin-right: 5px;
  /*display: block;*/
  /*float: left;*/
  /*margin-top: 1.2px;*/
}
</style>
